import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Navigate } from 'react-router-dom';
import { Page, BlockStack, Card, DataTable, Text, Badge, Tooltip, DescriptionList, Divider, Button, ButtonGroup, InlineStack, Banner, EmptyState } from '@shopify/polaris';
import {
  SaveIcon
} from '@shopify/polaris-icons';

import PageFooter from '../partials/PageFooter';
import LoadingSpinner from '../partials/LoadingSpinner';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import { getLiveResults, getLiveResult } from '../../redux/actions/batchInventoryResults';

const LiveResults = ({ shopUrl, payload, batchInventoryResults, loadLiveResults, requiresRefresh, downloadCsv, downloadUrl }) => {
  useEffect(() => {
    loadLiveResults(shopUrl, payload);
  }, []);

  useEffect(() => {
    if(downloadUrl) {
      let win = window.open(downloadUrl, '_blank');
      win.focus();
    }
  }, [downloadUrl])

  const batchRow = (csv) => {
    return [
      csv,
      <Button loading={batchInventoryResults.isDownloading} icon={SaveIcon} variant="primary" onClick={() => downloadCsv(shopUrl, payload, csv)}>Download</Button>
    ]
  }


  return(
    <Page
      title="Live Session Results"
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + window.location.search}}
    >
      { requiresRefresh &&
        <RequiresRefreshBanner />
      }
      <BlockStack gap="200">
        <Banner title="Storage Note" onDismiss={() => {}}>
          <p><strong>Live session data is only stored for 2 weeks.</strong> Click the "Download" button to download a live session results CSV.</p>
        </Banner>

        <Card>
          <BlockStack gap="200">
            <Text variant="headingLg" as="h5">Saved Session CSVs</Text>

            { !batchInventoryResults.isFetching && (batchInventoryResults.liveResults.length > 0) &&
              <DataTable
                columnContentTypes={[
                  'text',
                  'text'
                ]}
                headings={[
                  'CSV Saved Date',
                  'Download'
                ]}
                rows={batchInventoryResults.liveResults.map((csv) => batchRow(csv))}
              />
            }

            { !batchInventoryResults.isFetching && (batchInventoryResults.liveResults.length === 0) &&
              <Text>No live inventory modificaiton sessions found.</Text>
            }

            { batchInventoryResults.isFetching &&
              <LoadingSpinner size="small" statusText="Loading live inventory session results" />
            }

          </BlockStack>

        </Card>

      </BlockStack>
    </Page>  
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  batchInventoryResults: state.batchInventoryResults,
  downloadUrl: state.batchInventoryResults.downloadUrl,
  
});

const mapDispatchToProps = (dispatch) => ({
  loadLiveResults: (shopUrl, payload) => dispatch(getLiveResults(shopUrl, payload)),
  downloadCsv: (shopUrl, payload, csvId) => dispatch(getLiveResult(shopUrl, payload, csvId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveResults);